// extracted by mini-css-extract-plugin
export default {"cls1":"hsRFu1oz17gAbdvLkncR","cls2":"RRcqt7zvQeVE0V2bmHIA hsRFu1oz17gAbdvLkncR","isPhone":"U7OZXQV91YAj1QxOlhIj"};